/* eslint-disable import/prefer-default-export */
export const backgroundColor = '#f4f4f4';

// this is for scrolling ad group sections into view by offsetting the scroll position due to the fixed header
export const scrollTargetStyle = { position: 'relative' as 'absolute', top: -150 };

export const TOP_NAVIGATION_HEIGHT = 64; // this is the height of the top navigation bar
export const SUB_NAVIGATION_HEIGHT = 48; // this is the height of the sub navigation bar
export const LEFT_NAV_WIDTH = 340; // this is the width of the left navigation bar
